export const projectData = [
    {
      title: 'E-learning Website',
      description: 'As an ITI Graduation Project: built using React and Next.js for purchasing courses, managing scholarships, and registering students and instructors. The website was designed to be intuitive, allowing both students and instructors to easily navigate and interact with the platform features.',
      imgPath: '/Capture.PNG',
      gitHubLink: 'https://github.com/mahmoudbadr00/E-Learning-Website-Next-React-JS-ITI-Graduation-Project',
      demoLink:'https://e-learning-website-next-react-js-iti-graduation-project.vercel.app/',
      technologies: ['React', 'Next.js', 'Material-UI', 'Node.js']
    },
    {
      title: 'E-learning Mobile App',
      description: 'As a continuation of the e-learning platform, the mobile version was developed using React Native to offer students and instructors the same functionality as the web platform but optimized for mobile devices.',
      imgPath: '/e-learning-app.jpg',
      gitHubLink: 'https://github.com/mahmoudbadr00/E-learning-App-ITI-Graduation-Project-React-Native',
      demoLink:'https://drive.google.com/file/d/1iN8HH9wj17j0eU0fpTE6SMqkKxRE9ZVU/view?usp=drivesdk',
      technologies: ['React Native', 'Redux', 'Node.js']
    },
    {
      title: 'Adopt Pets Website',
      description: 'A website built with React for adopting pets, featuring browsing options and detailed pet information.',
      imgPath: '/adopt.PNG',
      gitHubLink: 'https://github.com/mahmoudbadr00/Adopt-pets-website-React',
      demoLink:'https://adoptme-coral.vercel.app/',
      technologies: ['React', 'CSS', 'Firebase']
    },
    {
      title: 'Portfolio Website',
      description: 'A professional Portfolio Website using React and Material UI to showcase my skills, projects, and experiences.',
      imgPath: '/portfolio.PNG',
      gitHubLink: 'https://github.com/mahmoudbadr00/Portfolio-Website-React-JS',
      demoLink:'https://portfoliowebsitereactmahmoudbadr.vercel.app/',
      technologies: ['React', 'Material-UI', 'CSS']
    },
    {
      title: 'News App',
      description: 'Developed a news application using Flutter, featuring real-time updates from various news sources through API integration.',
      imgPath: '/maxresdefault.jpg',
      gitHubLink: 'https://github.com/mahmoudbadr00/News-APP-Flutter',
      demoLink:'https://www.linkedin.com/posts/mahmoud-badr-b73516242_flutter-newsabrapis-flutterdevelopment-activity-7191561131474173952-f087?utm_source=share&utm_medium=member_desktop',
      technologies: ['Flutter', 'Dart', 'REST API']
    },
    {
      title: 'Muslim App',
      description: 'A Flutter-based app featuring the complete Quran, supplications, Tasbeeh counter, and daily prayers.',
      imgPath: '/muslimpro.jpg',
      gitHubLink: 'https://github.com/mahmoudbadr00/Muslim-app-Flutter',
      demoLink:'https://drive.google.com/file/d/1F4op3SN1sTObGq06Z0Y-OBITczcy7nOh/view?usp=sharing',
      technologies: ['Flutter', 'Dart', 'SQLite']
    },
    {
      title: 'To-Do App',
      description: 'A simple task management app built with React Native for adding and organizing daily to-do items.',
      imgPath: '/To-Do-List-App.jpg',
      gitHubLink: 'https://github.com/mahmoudbadr00/To-Do-App-React-Native',
      demoLink:'',
      technologies: ['React Native', 'AsyncStorage']
    },
    {
      title: 'Admin Dashboard',
      description: 'Admin Dashboard built with Next.js and React.js for managing users, products, and displaying real-time statistics with a responsive design.',
      imgPath: '/admin-dashboard.png',
      gitHubLink: 'https://github.com/mahmoudbadr00/E-Learning-Website-Next-React-JS-ITI-Graduation-Project',
      technologies: ['Next.js', 'React', 'Material-UI', 'Charts.js'],
      demoLink:'https://www.linkedin.com/posts/mahmoud-badr-b73516242_elearningwebsite-graduationproject-react-activity-7259571938447028224-4nh-?utm_source=share&utm_medium=member_desktop',
    },
    {
      title: 'Break Coffee website',
      description: 'Built with React and Bootstrap, offering a responsive design, dark mode, bilingual support (Arabic & English), and installable as a Progressive Web App (PWA) for enhanced accessibility.',
      imgPath: '/BreakCoffee.PNG',
      gitHubLink: 'https://github.com/mahmoudbadr00/coffee-website',
      demoLink:'https://break-coffee-website.vercel.app/',
      technologies: ['Next.js', 'React', 'Bootstrap']
    },
    {
      title: 'INTERVIEW website',
      description: 'To help job applicants review interview questions for most fields. Built with React and Matrial UI, offering a responsive design, and installable as a Progressive Web App (PWA) for enhanced accessibility.',
      imgPath: '/interview.PNG',
      gitHubLink: 'https://github.com/mahmoudbadr00/Interview-questions',
      demoLink:'https://interview-questions-puce.vercel.app/',
      technologies: ['React', 'Matrial UI']
    },
    {
      title: 'Simple Music Player',
      description: 'It was one of the required projects in CodeAlpha\'s training, designed in HTML, CSS and JavaScript.',
      imgPath: '/musicPlayer.png',
      gitHubLink: 'https://github.com/mahmoudbadr00/CodeAlpha_Music_Player',
      demoLink:'https://music-player-by-badr.vercel.app/',
      technologies: ['JavaScript']
    },
    {
      title: 'TIK TAK TOE App',
      description: 'A X/O game developed in Flutter.',
      imgPath: '/xo.PNG',
      gitHubLink: 'https://github.com/mahmoudbadr00/Tik-Tak-Toe-Game-Flutter',
      demoLink:'https://drive.google.com/file/d/1Dbspq0mP28_iljkjugUnHk_k6OjHmo6b/view?usp=sharing',
      technologies: ['Flutter']
    },
  ];